import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveList } from '../actions/RichListActions.js';

const RichLists = [
  { title: 'Financial Review Rich List 2020', code: 'AFR2020' },
  { title: "The Australian Richest 250 2020", code: 'Oz2020' },
  { title: 'Forbes Billionaires 2021', code: 'FORBES2021' },
];

const RichListButtons = () => {
  const dispatch = useDispatch();

  const richLists = useSelector((state) => state.richLists);
  const { activeList } = richLists;

  return (
    <div className="w-full flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2">
      {RichLists.map((item, index) => {
        return (
          <button
            key={index}
            onClick={() => dispatch(setActiveList(item.code))}
            className={`${
              item.code === activeList
                ? 'bg-purple-600 text-white'
                : 'bg-white text-purple-600'
            } focus:outline-none uppercase font-mono font-medium py-2 px-6 rounded-lg `}
          >
            {item.title}
          </button>
        );
      })}
    </div>
  );
};

export default RichListButtons;
